import {useState} from '@wordpress/element';
import {BaseControl, ToggleControl} from '@wordpress/components';

export default function CheckboxOption({attributeName, label, help, attributes, setAttributes, onChange}) {
	const [isChecked, setIsChecked] = useState(attributes[attributeName]);

	return (
		<BaseControl>
			<ToggleControl
				label={label}
				help={help}
				checked={isChecked}
				onChange={isChecked => {

					let _attributes = [];

					_attributes[attributeName] = isChecked;

					setAttributes(_attributes);
					setIsChecked((isChecked));

					onChange && onChange(isChecked)
				}}
			/>
		</BaseControl>
	);
}
